/*
 * ヒーローバナー動画の自動再生フォールバック。
 *
 * TikTok / Instagram / LINE などのアプリ内ブラウザ（iOS WKWebView）では、
 * `autoplay muted playsinline` が揃っていても play() が reject されることがある。
 * 属性任せにせず、以下の順で再生を試みる:
 *   1. 画面内に入ったタイミングで play()
 *   2. reject されたら、最初のユーザー操作（tap / scroll 等）で再試行
 * ユーザージェスチャ後の play() は WebView でも必ず許可される。
 */
if (!window.__every_hero_banner_video_initialized) {
  window.__every_hero_banner_video_initialized = true;

  (function () {
    var GESTURE_EVENTS = ['touchstart', 'pointerdown', 'click', 'scroll', 'keydown'];
    var pending = [];
    var gestureBound = false;

    function bindGestureRetry() {
      if (gestureBound) return;
      gestureBound = true;

      var retry = function () {
        gestureBound = false;

        var queued = pending;
        pending = [];
        queued.forEach(attemptPlay);
      };

      GESTURE_EVENTS.forEach(function (name) {
        document.addEventListener(name, retry, { capture: true, once: true, passive: true });
      });
    }

    function attemptPlay(video) {
      // 再生済みなら何もしない
      if (!video.paused && !video.ended) return;

      // WebView によっては属性が効かないことがあるためプロパティでも明示する
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;

      var result = video.play();
      if (!result || typeof result.catch !== 'function') return;

      result.catch(function () {
        if (pending.indexOf(video) === -1) pending.push(video);
        bindGestureRetry();
      });
    }

    function observe(video) {
      if (video.dataset.heroVideoBound === 'true') return;
      video.dataset.heroVideoBound = 'true';

      // メタデータが揃う前の play() は失敗しやすいので、読み込み完了後にも試す
      video.addEventListener('loadeddata', function () {
        attemptPlay(video);
      });

      if (!('IntersectionObserver' in window)) {
        attemptPlay(video);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) attemptPlay(entry.target);
          });
        },
        { threshold: 0.1 }
      );

      observer.observe(video);
    }

    function init() {
      document.querySelectorAll('.hero-banner__media video').forEach(observe);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // テーマエディタでセクションを編集したときの再初期化
    document.addEventListener('shopify:section:load', init);
  })();
}
